import React, { Component } from "react";
import { Accessor } from "IZOX/STATIC";
import PropsType from "prop-types";
import { HStack } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class FadeInOutView extends Component {

  static propTypes = {
    onMounted: PropsType.func,
    style: PropsType.any
  };

  static defaultProps = {
    onMounted: null,
    style: {}
  };

  constructor(){
    super();
    this.state = {
      appear: false,
      duration: 0
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(FadeInOutView.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), () => {
      if(this.props.onMounted){
        this.props.onMounted({
          fadeIn: this.fadeIn,
          fadeOut: this.fadeOut
        });
      }
      callback?.();
    });
  };

  fadeIn = (duration) => {
    this.setState({
      appear: true,
      duration: duration
    });
  };

  fadeOut = (duration) => {
    this.setState({
      appear: false,
      duration: duration
    });
  };

  render(){
    let {style, children} = this.props;
    let {appear, duration} = this.state;
    return (
      <HStack opacity={appear ? 1: 0} style={{
        ...style, 
        transition: `opacity ${duration/1000}s`,
      }}>
        {children}
      </HStack>
    );
  }

}

export default FadeInOutView;
